export default __webpack_public_path__ + "static/media/kibawe_mdrrmo_logo.0a93e6fa.png";